/* ------------------------------------------------------------------------------
 *
 *  # Categoria Management Components
 *
 *  Grid de Categorías con acciones
 *
 * ---------------------------------------------------------------------------- */

import { destroyDataTable, initGenericDataTable } from '../integrations/datatables.js';

// Callback reference
let categoriaCallbacks = null;

export function initCategoriaTable(categorias) {
    destroyDataTable('categoriaTable');

    const tableData = categorias.map(c => [
        generateActions(c),
        c.nombre,
        c.descripcion,
        c.tipoCategoriaNombre || '-',
        c.orden,
        c.activa ? 'Activo' : 'Inactivo'
    ]);

    const options = {
        data: tableData,
        columns: [
            { title: 'Acciones', orderable: false, className: 'text-center', width: '120px' },
            { title: 'Nombre' },
            { title: 'Descripción' },
            { title: 'Tipo de Categoría' },
            { title: 'Orden', className: 'text-center' },
            { title: 'Estado', className: 'text-center' }
        ],
        order: [[1, 'asc']]
    };

    initGenericDataTable('categoriaTable', options);
}

function generateActions(categoria) {
    return `
        <div class="d-inline-flex">
            <a href="javascript:void(0)" class="text-body me-2" onclick="window.sfBlazorSB.categorias.edit(${categoria.id})" title="Editar">
                <i class="ph-pencil"></i>
            </a>
            <a href="javascript:void(0)" class="text-body" onclick="window.sfBlazorSB.categorias.delete(${categoria.id})" title="Eliminar">
                <i class="ph-trash"></i>
            </a>
        </div>
    `;
}

// Refresh table
export function refreshCategoriaTable(categorias) {
    destroyDataTable('categoriaTable');
    initCategoriaTable(categorias);
}

// Set callbacks
export function setCategoriaCallbacks(dotNetRef) {
    categoriaCallbacks = dotNetRef;
}

// Edit action
export function editCategoria(id) {
    if (categoriaCallbacks) {
        categoriaCallbacks.invokeMethodAsync('EditCategoria', id);
    }
}

// Delete action
export async function deleteCategoria(id) {
    const result = await window.swalInit.fire({
        title: '¿Eliminar Categoría?',
        text: '¿Estás seguro de que deseas eliminar esta categoría?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dc3545'
    });

    if (result.isConfirmed && categoriaCallbacks) {
        await categoriaCallbacks.invokeMethodAsync('DeleteCategoria', id);
    }
}
